import PropTypes from "prop-types"
import React from "react"

import Heading from "src/components/Heading"

const AuthInterstitialLayout = ({
  authPhotoUrl,
  children,
  header,
  subtitle,
  title,
}) => (
  <div className="-mt-5 flex min-h-screen w-full flex-wrap items-stretch">
    <div className="flex w-full flex-col items-center justify-center px-8 py-16 md:w-3/5 md:px-12 lg:px-20">
      {header}
      <div className="text-center">
        <Heading.PageTitle>{title}</Heading.PageTitle>
      </div>
      <p className="mb-0 mt-2 text-center text-base text-gray-700">
        {subtitle}
      </p>
      {children}
    </div>

    <div
      data-testid="auth-photo-panel"
      className="hidden bg-gray-200 md:block md:w-2/5"
      style={
        authPhotoUrl
          ? {
              backgroundImage: `url(${authPhotoUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }
          : undefined
      }
    />
  </div>
)

AuthInterstitialLayout.propTypes = {
  authPhotoUrl: PropTypes.string,
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  subtitle: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
}

export default AuthInterstitialLayout
